export default __webpack_public_path__ + "static/media/Appointments.df96d7d8.svg";